// src/components/AlertMessage.js
import React from "react";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const AlertCustom = ({ show, message, severity, onClose }) => {
  return (
    <Collapse in={show}>
      <Alert
        severity={severity || "error"}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        <p>{message}</p>
      </Alert>
    </Collapse>
  );
};

export default AlertCustom;